import { render, staticRenderFns } from "./formsInput.vue?vue&type=template&id=4ef65a7d&"
import script from "./formsInput.vue?vue&type=script&lang=js&"
export * from "./formsInput.vue?vue&type=script&lang=js&"
import style0 from "./formsInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports